module.exports = __webpack_public_path__ + "svg/new-mobilepay-small.50a418fa3207a2a5743e4b64a6d8f8ce.svg";